import Rx from 'rxjs/Rx';

export default class DashboardService {
    constructor(host, $poller, $http) {
        this.host = host;
        this.$poller = $poller;
        this.$http = $http;
    }

    getCashierList(date) {
        return Rx.Observable.fromPromise(this.$http({
            method: 'GET',
            url: this.host + '/api/accounts/cashiers',
            params: { date: date }
        }).then(
            (resp) => resp.data.cashiers,
            (resp) => []
            ));
    }

    getRecentOrders(date, cashier_id = undefined, table_code = undefined, limit = undefined) {
        this.$poller.stopPolling(this.host + '/api/accounts/orders/recents');
        return this.$poller.startPolling(this.host + '/api/accounts/orders/recents', {
            date: date,
            cashier_id: cashier_id,
            table_code: table_code,
            limit: limit
        });
    }

    getRecentSales(salesDate, offset) {
        this.$poller.stopPolling(this.host + '/api/accounts/cashier-sales/recents');
        return this.$poller.startPolling(this.host + '/api/accounts/cashier-sales/recents', {
            date: salesDate,
            offset: offset
        });
    }

    stopAllPolling() {
        this.$poller.stopPolling(this.host + '/api/accounts/orders/recents');
        this.$poller.stopPolling(this.host + '/api/accounts/cashier-sales/recents');
    }
}

DashboardService.$inject = ['host', '$poller', '$http'];


// WEBPACK FOOTER //
// ./src/app/services/dashboard.service.js